import React from 'react';
import {
  Stack,
  InputLabel,
  TextField,
  Grid,
  Typography,
  Box,
} from '@mui/material';

// MESSAGES
import AdminFormattedMessages from '../../messages/admin/AdminFormattedMessages';

const AuthorisedContactForm = () => {
  return (
    <Box>
      <Typography variant="h2" gutterBottom>
        {AdminFormattedMessages.authorizedAdmin}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }} required>
              {AdminFormattedMessages.name}
            </InputLabel>
            <TextField
              required
              name="contact_name"
              size="small"
              fullWidth
              variant="outlined"
            />
          </Stack>
        </Grid>

        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }}>
              {AdminFormattedMessages.mobilePhoneNumber}
            </InputLabel>
            <TextField
              name="contact_mobile"
              size="small"
              fullWidth
              variant="outlined"
            />
          </Stack>
        </Grid>

        <Grid size={12}>
          <Stack
            sx={{
              flexDirection: { md: 'row' },
              alignItems: { md: 'center' },
              gap: { md: 2 },
            }}
          >
            <InputLabel sx={{ minWidth: 200 }} required>
              {AdminFormattedMessages.emailAddress}
            </InputLabel>
            <TextField required name="contact_email" size="small" fullWidth />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthorisedContactForm;
